module.exports = __webpack_public_path__ + "img/bc-sign-in-papyrus-white.99b80d21.jpg";